import { Button, Col, Container, Form, Modal, Row, Spinner, Table } from 'react-bootstrap'
import ReactHtmlParser from 'react-html-parser';

export default function GenericConfirmModal({ title, bodyMsg, isShow, handleCloseCb, onConfirmCb, confirmBtnCaption }) {
    return (
        <Modal show={isShow} onHide={() => handleCloseCb()} backdrop={'static'}>
            <Modal.Header>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {ReactHtmlParser(bodyMsg)}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleCloseCb}>
                    Close
                </Button>
                <Button variant="light" style={{ color: 'white', background: 'rgba(0, 127, 97, 1)' }}
                        onClick={onConfirmCb}>
                    {confirmBtnCaption ?? 'Submit'}
                </Button>
            </Modal.Footer>
        </Modal>
    )
};

